import React from 'react';
import ReportOptions from './reportOptions';
import ReportSummary from './reportSummary';
import Loader from 'components/loader';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage} from 'react-intl';
import CustomerAPI from 'api/customer';
import {makeCancelable} from 'helpers/cancelablePromise';
import reportSummary from './reportSummary';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';

class TruBlue extends React.Component {
  state = {
    dateFrom: null,
    dateTo: null,
    loaded: true,
    showNoDataMessage: false,
    status: '',
    store: 0,
    summaryData: [],
    error: false,
  };

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  updateReportData = (store, status, from, to) => {
    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        summaryData: [],
      });
    }

    (this.fetching = makeCancelable(CustomerAPI.getTruBlueSummaryReport(from.format('MM-DD-YYYY'), to.format('MM-DD-YYYY'), status, store)))
      .then(res => {
        if (res && res.TotalAccounts > 0) {
          this.setState({
            dateFrom: from.format(dateTimeFormats.numeralDate),
            dateTo: to.format(dateTimeFormats.numeralDate),
            showNoDataMessage: false,
            status: status,
            store: store,
            summaryData: res,
            loaded: true,
            error: false,
          });
          return;
        }
        this.setState({
          showNoDataMessage: true,
          loaded: true,
          error: false,
        });
      }).catch(e => {
        console.log(e);
        if (e && e.canceled) {return;}
        this.setState({loaded: true, error: true});
      });
  };

  render() {
    return <div className="report-container">
      <span>
        <FormattedMessage id="reports.trublue.accounts.description"/>
      </span>
      <ReportOptions updateReportData={this.updateReportData}
                     branches={this.props.branches}/>
      <Loader loaded={this.state.loaded}>
        <ReportSummaryErrorHandler error={this.state.error}>
          <ReportSummary data={this.state.summaryData}
                       dateFrom={this.state.dateFrom}
                       dateTo={this.state.dateTo}
                       status={this.state.status}
                       store={this.state.store}
                       POSActive={this.props.POSActive}
                       showNoDataMessage={this.state.showNoDataMessage}/>
        </ReportSummaryErrorHandler>

      </Loader>

    </div>;
  }
}

export default TruBlue;
